module.exports = __webpack_public_path__ + "static/media/tick-circle.32ca6a21.svg";